<template>
  <v-sheet rounded class="pa-4 text-caption mb-4">
    <div>{{station.name}}</div>
    <!-- div v-if="schedule.end">{{schedule.begin}} 〜 {{schedule.end}}</div -->
    <div v-if="car" class="carname">
      <span>{{car.maker}}</span>
      <span class="carname_span">{{car.name}}</span>
    </div>
    <div>{{summary}}</div>
    <div v-html="tags"></div>
    <div v-if="car.chargeText">基本料金&nbsp;{{car.chargeText}}</div>
    <div
      v-show="enableCar24Flg"
      class="carsummary_vkey_link"
    >
      <a :href="'/reserve/res/' + orgcode + '/vkey.pdf'">24時間貸出車両について</a>
    </div>
  </v-sheet>
</template>

<style>
.carname {
  width: 100%;
  border-bottom: solid 2px #ccc;
  margin-bottom: 8px;
}
.carname_span {
  display: inline-block;
  padding: 4px 0;
  font-size: 1.2rem;
  font-color: red;
  text-align: left;
  margin-right: 8px;
}
.chargeText {
  margin-bottom: 8px;
}
.AttributesIcon {
  display: inline-block;
  padding: 2px 4px;
  margin-right: 4px;
  margin-bottom: 4px;
  border-radius: 4px;
}
.Attributes_Dark {
  color: #fff;
}
.Attributes_Bright {
  color: #000;
}
.carsummary_vkey_link {
  width: 100%;
  height: 16px;
  margin-top: 12px;
  margin-bottom: 12px;
}
.carsummary_vkey_link > a {
  display: inline-block;
  float: right;
  padding: 4px 8px;
  border-radius: 15px;
  border: 1px #cccccc solid;
  text-decoration: none;
  text-align: center;
}
</style>

<script>
export default {
  name: 'CBookSummarySheet',

  computed: {
    station () {
      return this.getters['book/station']
    },

    orgcode () {
      return this.getters['org/code']
    },

    schedule () {
      return this.getters['book/schedule']
    },

    car () {
      return this.getters['book/car']
    },

    enableCar24Flg () {
      let enableCar24Flg = false
      if (this.car.attributes.keykey === 1 || this.car.attributes.vkey === 1) {
        enableCar24Flg = true
      }
      return enableCar24Flg
    },

    summary () {
      const summary = []

      const attrs = this.car.attributes

      if (attrs.cc > 0) {
        summary.push(`${attrs.cc} cc`)
      }
      if (attrs.fuel) {
        summary.push(attrs.fuel)
      }
      if (attrs.seats > 0) {
        summary.push(`乗車${attrs.seats}名`)
      }
      if (attrs.bed > 0) {
        summary.push(`就寝${attrs.bed}名`)
      }
      if (attrs.days) {
        summary.push(`最大利用 ${attrs.days}日`)
      }

      return summary.join(' / ')
    },

    tags () {
      const tags = []

      const attrs = this.car.attributes

      if (attrs.vkey || attrs.keykey) {
        tags.push('24h貸出')
      }

      tags.push(attrs.smoke ? '喫煙' : '禁煙')
      tags.push(attrs.mission ? 'MT' : 'AT')
      if (attrs.drive === 1) {
        tags.push('4WD')
      }

      if (attrs.etc) {
        tags.push('ETC')
      }
      if (attrs.navi) {
        tags.push('カーナビ')
      }
      if (attrs.studless) {
        tags.push('スタッドレス可')
      }
      if (attrs.tags) {
        tags.push(...attrs.tags)
      }

      return this.tags_html(tags)
    }
  },

  methods: {
    font_color_class () {
      let ClassName = ''
      if (this.isDarkColor('primary') === true) {
        ClassName = 'Attributes_Dark'
      } else {
        ClassName = 'Attributes_Bright'
      }
      // 暫定で
      ClassName = 'Attributes_Dark'
      return ClassName
    },

    tags_html (tags) {
      // 配列かどうか
      if (Array.isArray(tags)) {
      } else {
        return
      }

      // テーマ色設定
      const FontColor = this.font_color_class()
      const SpanTag = '<span class="AttributesIcon ' + FontColor + ' primary">'

      // HTMLタグに変換
      let HTML = ''
      for (let i = 0; i < tags.length; i++) {
        HTML = HTML + SpanTag + tags[i] + '</span>'
      }

      return HTML
    }
  }
}
</script>
